import { AppState } from "store/store";
import { campaignMediaPlanForm } from "./state";

export function findCPCCampaignDataSelector(state: AppState) {
    const mediaPlan = campaignMediaPlanForm.selector(state.campaignState.campaignMediaPlanForm);

    if (!mediaPlan.isValid || mediaPlan.fields.priceModel.value !== "CPC") {
        return undefined;
    }

    const newMediaPlanData = {
        ...mediaPlan.data,
        interestTargeting: "",
        gender: "",
        deviceType: "",
        age: "",
        timetable: ""
    };

    return newMediaPlanData;
}
